module.exports = "<div class=busy-indicator-overlay><span class=busy-indicator-spinner></span></div>";